import React from 'react'

import FeedList from '../components/FeedList'

import PlayerList from '../data/PlayerList' // ditto

const Feed = (props) => {
  //console.log('FEED' + JSON.stringify(props));
  const list = props.activityList.map((event, index) => {

    // add 'playerName' to the scores info, and do a deep copy
    let newevent = JSON.parse(JSON.stringify(event));
    newevent.scores.forEach( (score) => {
      score.playerName = PlayerList[score.playerId].name;
    });
    //console.log('NEWEVENT: ' + JSON.stringify(newevent));
    return newevent;
  });

  return (
    <div className="afDiv">
      <h1 className="afHeader">Your Activity Feed</h1>
      <FeedList activityList={list}/>
    </div>
  );
};

export default Feed;



// WEBPACK FOOTER //
// ./src/containers/Feed.js